import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ActiveService } from 'src/app/active-service';
import { SetTimeForOrg } from 'src/app/interfaces/orgTime';
import { environment } from 'src/environments/environment';

import { OrgModel } from '../../../models/org.model';
import { ITaxProfile } from '../../interfaces/tax-profile';
import { TaxProfileModel } from '../../models/tax-profile';

import { IreceiptNotePayload } from './org.action';

@Injectable()
export class OrgService extends ActiveService {
    baseLink: string;
    constructor(
        public http: HttpClient,
        public store: Store
    ) {
        super(http, store);
        this.baseLink = environment.invoiceBaseURL;
    }

    self(): Observable<any> {
        return this.get('organizations/self').pipe(
            map((resp) => {
                return new OrgModel(resp[0]);
            }),
            catchError((error) => {
                if (error?.error?.models?.member) {
                    throw error.error.models.member;
                } else {
                    throw error;
                }
            })
        );
    }

    updateProfile(obj, orgId: string): Observable<any> {
        return this.put(`organizations/${orgId}`, obj).pipe(
            map((resp) => {
                return new OrgModel(resp?.models?.organization);
            }),
            catchError((error) => {
                throw error.error;
            })
        );
    }

    setOrgTime(obj: SetTimeForOrg, orgId: string): Observable<any> {
        return this.put(`settings/${orgId}/organization/rtm_business_hours`, obj).pipe(
            catchError((error) => {
                throw error.error;
            })
        );
    }
    setReceiptNote(obj: IreceiptNotePayload, orgId: string): Observable<any> {
        return this.put(`settings/${orgId}/organization/note`, obj).pipe(
            catchError((error) => {
                throw error.error;
            })
        );
    }

    // TaxProfile will Be added in MSVC Invoices on Backend
    addTaxProfile(organizationId: string, profileData: ITaxProfile): Observable<TaxProfileModel> {
        return this.http
            .post<TaxProfileModel>(`${this.baseLink}/organization/${organizationId}/profile/tax`, profileData)
            .pipe(
                catchError((error) => {
                    throw error;
                })
            );
    }
    updateTaxProfile(organizationId: string, profileData: ITaxProfile): Observable<TaxProfileModel> {
        return this.http.put<TaxProfileModel>(
            `${this.baseLink}/organization/${organizationId}/profile/tax/${profileData.id}`,
            profileData
        );
    }

    GetAllTaxProfile(orgId: string): Observable<TaxProfileModel[]> {
        return this.http.get<TaxProfileModel[]>(`${this.baseLink}/organization/${orgId}/profile/taxes`).pipe(
            map((resp: TaxProfileModel[]) => {
                return resp;
            })
        );
    }

    deleteTaxProfile(orgId: string, taxId: string): Observable<TaxProfileModel[]> {
        return this.http.delete<TaxProfileModel[]>(`${this.baseLink}/organization/${orgId}/profile/tax/${taxId}`).pipe(
            map((resp: TaxProfileModel[]) => {
                return resp;
            })
        );
    }
}
